module.exports = __webpack_public_path__ + "static/media/icon-hammer-white.88df186c.svg";